// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"720":"01241a75","908":"5853b2ce"}[chunkId] + ".js";
};